const initState = [
  "oooaaaaaooo",
  "oooooaooooo",
  "ooooooooooo",
  "aoooodooooa",
  "aooodddoooa",
  "aaoddkddoaa",
  "aooodddoooa",
  "aoooodooooa",
  "ooooooooooo",
  "oooooaooooo",
  "oooaaaaaooo",
].join("");

export default function getInitStateArray(): string[][] {
  const array1D = Array.from(initState);
  const array2D: string[][] = [];
  while (array1D.length) array2D.push(array1D.splice(0, 11));
  return array2D;
}
